import { APP_ROLES, type AppRole } from "../types";

// Almikia role names are business titles, shown in Spanish whatever the locale
export const ROLE_LABELS: Record<AppRole, string> = {
  direccion: "Dirección",
  lead_manager: "Lead Manager",
  lider: "Líder BPO",
  asesora: "Asesora",
  administracion: "Administración",
  compliance: "Compliance",
  contabilidad: "Contabilidad",
  auditoria: "Auditoría",
};

export const ROLE_CHOICES = APP_ROLES.map((role) => ({
  id: role,
  name: ROLE_LABELS[role],
}));
